import { useEffect, useRef, useState } from 'react'

/**
 * About block (handoff bloco 4). Collapsed to 3 lines with a "Ler mais" toggle
 * that only appears when the text actually overflows. Omitted when empty.
 */
export const PartnerAbout = ({ about }) => {
  const textRef = useRef(null)
  const [expanded, setExpanded] = useState(false)
  const [overflowing, setOverflowing] = useState(false)

  useEffect(() => {
    const el = textRef.current
    if (!el) return
    // scrollHeight > clientHeight while clamped ⇒ there is hidden text.
    setOverflowing(el.scrollHeight - el.clientHeight > 1)
  }, [about])

  if (!about) return null

  return (
    <section>
      <h2 className="m-0 mb-1.5 text-[15px] font-bold text-gray-900">Sobre</h2>
      <p
        ref={textRef}
        className={`m-0 text-[15px] leading-relaxed text-gray-800 ${
          expanded ? '' : 'line-clamp-3'
        }`}
      >
        {about}
      </p>
      {overflowing && (
        <button
          type="button"
          onClick={() => setExpanded(v => !v)}
          className="mt-1.5 bg-transparent p-0 py-1.5 text-sm font-semibold text-brand active:opacity-70"
        >
          {expanded ? 'Ler menos' : 'Ler mais'}
        </button>
      )}
    </section>
  )
}
